<template>
    <!--签到-->
  <div id="personsign">
    <h2 class="title">
      <a @click="back" class="prev"></a>
      日签
      <a href="" class="share">
        <img src="../../assets/icon/examscore_icon_share.png" alt="">
      </a>
    </h2>
    <dl class="date-score">
      <dt>
        <b>18</b> / 07
      </dt>
      <dd>
        积分：8
      </dd>
    </dl>
    <div class="main">

    </div>
    <div class="my">
      <div class="left">
        <img src="../../assets/img/personvip_img_avatar.png" alt="">
      </div>
      <div class="middle">
        <h4>独特的我们</h4>
        <p>123456789</p>
      </div>
    </div>
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  name: 'PersonSign',
  data () {
    return {
    }
  },
  methods: {
    back () {
      if (window.history.length <= 1) {
        this.router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
#personsign
  h2.title
    position: relative
    height: 1.08rem
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #050505
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: #fff
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #050505
        border-bottom: .03rem solid #050505
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
    a.share
      position: absolute
      top: .2rem
      right: .32rem
      img
        width: .38rem
        height: .38rem
  .date-score
    display: flex
    justify-content: space-between
    align-items: flex-end
    height: .84rem
    padding: 0 .4rem
    margin: .48rem 0 0
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    dt
      font-size: .28rem
      color: #3B3B3B
      b
        font-size: .84rem
        font-weight: normal
    dd
      font-size: .28rem
      color: #3B3B3B
  div.main
    height: 8rem
  div.my
    display: flex
    justify-content: left
    align-items: center
    height: .92rem
    padding: 0 .4rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    .left
      width: .92rem
      height: .92rem
      margin-right: .2rem
      img
        width: 100%
        height: 100%
    .middle
      h4
        font-size: .28rem
        color: #2F2F2F
        margin-bottom: .08rem
      p
        font-size: .2rem
        color: #A3A9B7
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
</style>



// WEBPACK FOOTER //
// src/components/personal/PersonSign.vue